// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/device.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PageRequest, PageResponse, PathTelemetry, RequestMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { Transport } from "./worker_pb";
import { file_nodebase_v1_worker } from "./worker_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/device.proto.
 */
export const file_nodebase_v1_device: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common, file_nodebase_v1_worker]);

/**
 * @generated from message nodebase.v1.Device
 */
export type Device = Message<"nodebase.v1.Device"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform: string;

  /**
   * @generated from field: string client_version = 5;
   */
  clientVersion: string;

  /**
   * Ed25519 public key: node auth, also used directly as the SSH authorized key.
   *
   * @generated from field: bytes api_public_key = 6;
   */
  apiPublicKey: Uint8Array;

  /**
   * Curve25519 public key: data plane (WireGuard).
   *
   * @generated from field: bytes wg_public_key = 7;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: nodebase.v1.DeviceState state = 8;
   */
  state: DeviceState;

  /**
   * @generated from field: string overlay_ip = 9;
   */
  overlayIp: string;

  /**
   * @generated from field: int64 last_seen_unix = 10;
   */
  lastSeenUnix: bigint;

  /**
   * The attachment the device last reported with its config poll (DeviceLink):
   * which worker endpoint it aims WireGuard at, and its view of the last
   * completed handshake. link_reported_unix dates the report.
   *
   * Address privacy: public addresses — the endpoint host here, the device's
   * own source address in wg_endpoint — are operator material. ListDevices
   * blanks both; only AdminListDevices carries them. Port and transport stay,
   * they are what "which path am I on" needs.
   *
   * @generated from field: string link_endpoint_host = 11;
   */
  linkEndpointHost: string;

  /**
   * @generated from field: uint32 link_endpoint_port = 12;
   */
  linkEndpointPort: number;

  /**
   * @generated from field: nodebase.v1.Transport link_transport = 13;
   */
  linkTransport: Transport;

  /**
   * @generated from field: int64 link_handshake_unix = 14;
   */
  linkHandshakeUnix: bigint;

  /**
   * @generated from field: int64 link_reported_unix = 15;
   */
  linkReportedUnix: bigint;

  /**
   * The worker-observed side of the same tunnel (heartbeat PeerStat): ground
   * truth for "does this device hold a live tunnel", per-device split of the
   * worker's cumulative counters, and the device's source address as the
   * worker sees it.
   *
   * @generated from field: int64 wg_handshake_unix = 16;
   */
  wgHandshakeUnix: bigint;

  /**
   * @generated from field: uint64 wg_rx_bytes = 17;
   */
  wgRxBytes: bigint;

  /**
   * @generated from field: uint64 wg_tx_bytes = 18;
   */
  wgTxBytes: bigint;

  /**
   * @generated from field: string wg_endpoint = 19;
   */
  wgEndpoint: string;

  /**
   * @generated from field: int64 wg_reported_unix = 20;
   */
  wgReportedUnix: bigint;

  /**
   * @generated from field: nodebase.v1.PathTelemetry path_telemetry = 21;
   */
  pathTelemetry?: PathTelemetry | undefined;

  /**
   * Control-owned rollout gate for independently keyed private overlay lanes.
   * 1 is the existing single-lane behavior; 2 is the current hard maximum.
   *
   * @generated from field: uint32 desired_private_lane_count = 22;
   */
  desiredPrivateLaneCount: number;
};

/**
 * Describes the message nodebase.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 0);

/**
 * PrivateOverlayLane is visible only to the Device it belongs to and to the
 * Worker desired config. It is not another workspace member, SSH identity, or
 * inbound address.
 *
 * @generated from message nodebase.v1.PrivateOverlayLane
 */
export type PrivateOverlayLane = Message<"nodebase.v1.PrivateOverlayLane"> & {
  /**
   * lane 0 is the Device message; auxiliary lanes start at 1
   *
   * @generated from field: uint32 lane_id = 1;
   */
  laneId: number;

  /**
   * @generated from field: string node_ref = 2;
   */
  nodeRef: string;

  /**
   * @generated from field: bytes wg_public_key = 3;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: string overlay_ip = 4;
   */
  overlayIp: string;
};

/**
 * Describes the message nodebase.v1.PrivateOverlayLane.
 * Use `create(PrivateOverlayLaneSchema)` to create a new message.
 */
export const PrivateOverlayLaneSchema: GenMessage<PrivateOverlayLane> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 1);

/**
 * @generated from message nodebase.v1.PrivateOverlayLaneKey
 */
export type PrivateOverlayLaneKey = Message<"nodebase.v1.PrivateOverlayLaneKey"> & {
  /**
   * @generated from field: uint32 lane_id = 1;
   */
  laneId: number;

  /**
   * @generated from field: bytes wg_public_key = 2;
   */
  wgPublicKey: Uint8Array;
};

/**
 * Describes the message nodebase.v1.PrivateOverlayLaneKey.
 * Use `create(PrivateOverlayLaneKeySchema)` to create a new message.
 */
export const PrivateOverlayLaneKeySchema: GenMessage<PrivateOverlayLaneKey> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 2);

/**
 * @generated from message nodebase.v1.RegisterDeviceRequest
 */
export type RegisterDeviceRequest = Message<"nodebase.v1.RegisterDeviceRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string platform = 3;
   */
  platform: string;

  /**
   * @generated from field: string client_version = 4;
   */
  clientVersion: string;

  /**
   * @generated from field: bytes api_public_key = 5;
   */
  apiPublicKey: Uint8Array;

  /**
   * @generated from field: bytes wg_public_key = 6;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: string workspace_id = 7;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.RegisterDeviceRequest.
 * Use `create(RegisterDeviceRequestSchema)` to create a new message.
 */
export const RegisterDeviceRequestSchema: GenMessage<RegisterDeviceRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 3);

/**
 * @generated from message nodebase.v1.RegisterDeviceResponse
 */
export type RegisterDeviceResponse = Message<"nodebase.v1.RegisterDeviceResponse"> & {
  /**
   * @generated from field: nodebase.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message nodebase.v1.RegisterDeviceResponse.
 * Use `create(RegisterDeviceResponseSchema)` to create a new message.
 */
export const RegisterDeviceResponseSchema: GenMessage<RegisterDeviceResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 4);

/**
 * @generated from message nodebase.v1.ListDevicesRequest
 */
export type ListDevicesRequest = Message<"nodebase.v1.ListDevicesRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: nodebase.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.ListDevicesRequest.
 * Use `create(ListDevicesRequestSchema)` to create a new message.
 */
export const ListDevicesRequestSchema: GenMessage<ListDevicesRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 5);

/**
 * @generated from message nodebase.v1.ListDevicesResponse
 */
export type ListDevicesResponse = Message<"nodebase.v1.ListDevicesResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * @generated from field: nodebase.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message nodebase.v1.ListDevicesResponse.
 * Use `create(ListDevicesResponseSchema)` to create a new message.
 */
export const ListDevicesResponseSchema: GenMessage<ListDevicesResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 6);

/**
 * @generated from message nodebase.v1.RenameDeviceRequest
 */
export type RenameDeviceRequest = Message<"nodebase.v1.RenameDeviceRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * A display name, not a DNS label: Chinese, spaces and emoji are all kept.
   * The server strips control characters and surrounding whitespace, and
   * rejects a name that is empty once stripped.
   *
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message nodebase.v1.RenameDeviceRequest.
 * Use `create(RenameDeviceRequestSchema)` to create a new message.
 */
export const RenameDeviceRequestSchema: GenMessage<RenameDeviceRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 7);

/**
 * @generated from message nodebase.v1.RenameDeviceResponse
 */
export type RenameDeviceResponse = Message<"nodebase.v1.RenameDeviceResponse"> & {
  /**
   * @generated from field: nodebase.v1.Device device = 1;
   */
  device?: Device | undefined;

  /**
   * Other live devices in this workspace that already carry the same name.
   * Duplicates are allowed on purpose — two machines their owner genuinely
   * calls "Mac" should not be forced apart by a suffix — so this is advisory
   * and the rename has already happened when it is non-empty.
   *
   * @generated from field: repeated string duplicate_device_ids = 2;
   */
  duplicateDeviceIds: string[];
};

/**
 * Describes the message nodebase.v1.RenameDeviceResponse.
 * Use `create(RenameDeviceResponseSchema)` to create a new message.
 */
export const RenameDeviceResponseSchema: GenMessage<RenameDeviceResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 8);

/**
 * @generated from message nodebase.v1.RevokeDeviceRequest
 */
export type RevokeDeviceRequest = Message<"nodebase.v1.RevokeDeviceRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;
};

/**
 * Describes the message nodebase.v1.RevokeDeviceRequest.
 * Use `create(RevokeDeviceRequestSchema)` to create a new message.
 */
export const RevokeDeviceRequestSchema: GenMessage<RevokeDeviceRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 9);

/**
 * @generated from message nodebase.v1.RevokeDeviceResponse
 */
export type RevokeDeviceResponse = Message<"nodebase.v1.RevokeDeviceResponse"> & {
};

/**
 * Describes the message nodebase.v1.RevokeDeviceResponse.
 * Use `create(RevokeDeviceResponseSchema)` to create a new message.
 */
export const RevokeDeviceResponseSchema: GenMessage<RevokeDeviceResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 10);

/**
 * @generated from message nodebase.v1.SubmitDiagnosticReportRequest
 */
export type SubmitDiagnosticReportRequest = Message<"nodebase.v1.SubmitDiagnosticReportRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * Empty is valid before the first successful device registration.
   *
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: string client_version = 3;
   */
  clientVersion: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform: string;

  /**
   * @generated from field: string bundle = 5;
   */
  bundle: string;

  /**
   * The released UI/CLI disclosure accepted by the user. This is versioned so
   * a materially different collection contract cannot silently reuse consent.
   *
   * @generated from field: string disclosure_version = 6;
   */
  disclosureVersion: string;

  /**
   * UTC wall-clock anchor for aligning the bounded client window with control
   * plane, Worker, and Edge logs. Milliseconds preserve short path rotations.
   *
   * @generated from field: int64 collected_unix_ms = 7;
   */
  collectedUnixMs: bigint;
};

/**
 * Describes the message nodebase.v1.SubmitDiagnosticReportRequest.
 * Use `create(SubmitDiagnosticReportRequestSchema)` to create a new message.
 */
export const SubmitDiagnosticReportRequestSchema: GenMessage<SubmitDiagnosticReportRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 11);

/**
 * @generated from message nodebase.v1.SubmitDiagnosticReportResponse
 */
export type SubmitDiagnosticReportResponse = Message<"nodebase.v1.SubmitDiagnosticReportResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: int64 received_unix = 2;
   */
  receivedUnix: bigint;

  /**
   * @generated from field: int64 expires_unix = 3;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.SubmitDiagnosticReportResponse.
 * Use `create(SubmitDiagnosticReportResponseSchema)` to create a new message.
 */
export const SubmitDiagnosticReportResponseSchema: GenMessage<SubmitDiagnosticReportResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 12);

/**
 * @generated from message nodebase.v1.SubmitFeedbackRequest
 */
export type SubmitFeedbackRequest = Message<"nodebase.v1.SubmitFeedbackRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string client_version = 2;
   */
  clientVersion: string;

  /**
   * @generated from field: string platform = 3;
   */
  platform: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * Optional, and supplied only after the person explicitly chooses to discuss
   * a report they already sent. The report remains governed by its shorter
   * retention window; this link never extends or duplicates diagnostic data.
   *
   * @generated from field: string diagnostic_report_id = 5;
   */
  diagnosticReportId: string;
};

/**
 * Describes the message nodebase.v1.SubmitFeedbackRequest.
 * Use `create(SubmitFeedbackRequestSchema)` to create a new message.
 */
export const SubmitFeedbackRequestSchema: GenMessage<SubmitFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 13);

/**
 * @generated from message nodebase.v1.SubmitFeedbackResponse
 */
export type SubmitFeedbackResponse = Message<"nodebase.v1.SubmitFeedbackResponse"> & {
  /**
   * @generated from field: string feedback_id = 1;
   */
  feedbackId: string;

  /**
   * @generated from field: int64 received_unix = 2;
   */
  receivedUnix: bigint;

  /**
   * @generated from field: int64 expires_unix = 3;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.SubmitFeedbackResponse.
 * Use `create(SubmitFeedbackResponseSchema)` to create a new message.
 */
export const SubmitFeedbackResponseSchema: GenMessage<SubmitFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 14);

/**
 * @generated from message nodebase.v1.GetEnhancedDiagnosticPlanRequest
 */
export type GetEnhancedDiagnosticPlanRequest = Message<"nodebase.v1.GetEnhancedDiagnosticPlanRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: string client_version = 3;
   */
  clientVersion: string;

  /**
   * @generated from field: repeated string supported_profile_ids = 4;
   */
  supportedProfileIds: string[];
};

/**
 * Describes the message nodebase.v1.GetEnhancedDiagnosticPlanRequest.
 * Use `create(GetEnhancedDiagnosticPlanRequestSchema)` to create a new message.
 */
export const GetEnhancedDiagnosticPlanRequestSchema: GenMessage<GetEnhancedDiagnosticPlanRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 15);

/**
 * @generated from message nodebase.v1.EnhancedDiagnosticCandidate
 */
export type EnhancedDiagnosticCandidate = Message<"nodebase.v1.EnhancedDiagnosticCandidate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: nodebase.v1.Transport transport = 2;
   */
  transport: Transport;

  /**
   * @generated from field: string profile_id = 3;
   */
  profileId: string;

  /**
   * Sensitive connection material. The client must use it in memory only and
   * must never include it in results, logs, or a diagnostic report.
   *
   * @generated from field: string server = 4;
   */
  server: string;

  /**
   * @generated from field: string server_name = 5;
   */
  serverName: string;

  /**
   * @generated from field: string carrier_password = 6;
   */
  carrierPassword: string;

  /**
   * @generated from field: string salamander_password = 7;
   */
  salamanderPassword: string;

  /**
   * @generated from field: string route_ticket = 8;
   */
  routeTicket: string;

  /**
   * @generated from field: bool strict_mode = 9;
   */
  strictMode: boolean;
};

/**
 * Describes the message nodebase.v1.EnhancedDiagnosticCandidate.
 * Use `create(EnhancedDiagnosticCandidateSchema)` to create a new message.
 */
export const EnhancedDiagnosticCandidateSchema: GenMessage<EnhancedDiagnosticCandidate> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 16);

/**
 * @generated from message nodebase.v1.GetEnhancedDiagnosticPlanResponse
 */
export type GetEnhancedDiagnosticPlanResponse = Message<"nodebase.v1.GetEnhancedDiagnosticPlanResponse"> & {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId: string;

  /**
   * @generated from field: int64 expires_unix = 2;
   */
  expiresUnix: bigint;

  /**
   * @generated from field: uint32 duration_seconds_per_candidate = 3;
   */
  durationSecondsPerCandidate: number;

  /**
   * @generated from field: uint32 packet_bytes = 4;
   */
  packetBytes: number;

  /**
   * @generated from field: uint32 packets_per_second = 5;
   */
  packetsPerSecond: number;

  /**
   * @generated from field: uint32 logical_flows = 6;
   */
  logicalFlows: number;

  /**
   * @generated from field: repeated nodebase.v1.EnhancedDiagnosticCandidate candidates = 7;
   */
  candidates: EnhancedDiagnosticCandidate[];
};

/**
 * Describes the message nodebase.v1.GetEnhancedDiagnosticPlanResponse.
 * Use `create(GetEnhancedDiagnosticPlanResponseSchema)` to create a new message.
 */
export const GetEnhancedDiagnosticPlanResponseSchema: GenMessage<GetEnhancedDiagnosticPlanResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_device, 17);

/**
 * @generated from enum nodebase.v1.DeviceState
 */
export enum DeviceState {
  /**
   * @generated from enum value: DEVICE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: DEVICE_STATE_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: DEVICE_STATE_REVOKED = 3;
   */
  REVOKED = 3,
}

/**
 * Describes the enum nodebase.v1.DeviceState.
 */
export const DeviceStateSchema: GenEnum<DeviceState> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_device, 0);

/**
 * DeviceService handles device registration, listing, and revocation.
 *
 * @generated from service nodebase.v1.DeviceService
 */
export const DeviceService: GenService<{
  /**
   * @generated from rpc nodebase.v1.DeviceService.RegisterDevice
   */
  registerDevice: {
    methodKind: "unary";
    input: typeof RegisterDeviceRequestSchema;
    output: typeof RegisterDeviceResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.DeviceService.ListDevices
   */
  listDevices: {
    methodKind: "unary";
    input: typeof ListDevicesRequestSchema;
    output: typeof ListDevicesResponseSchema;
  },
  /**
   * RenameDevice gives a device the name its owner calls it, replacing the
   * hostname registration reported. The name becomes the user's from that
   * moment: re-registration stops overwriting it, so a reinstall cannot
   * silently revert "书房台式机" to "DESKTOP-9F3K2A1".
   *
   * @generated from rpc nodebase.v1.DeviceService.RenameDevice
   */
  renameDevice: {
    methodKind: "unary";
    input: typeof RenameDeviceRequestSchema;
    output: typeof RenameDeviceResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.DeviceService.RevokeDevice
   */
  revokeDevice: {
    methodKind: "unary";
    input: typeof RevokeDeviceRequestSchema;
    output: typeof RevokeDeviceResponseSchema;
  },
  /**
   * SubmitDiagnosticReport is always user-triggered. The client applies its
   * strict share scrub before sending; the server repeats that scrub before
   * storage and expires the report after a short retention window.
   *
   * @generated from rpc nodebase.v1.DeviceService.SubmitDiagnosticReport
   */
  submitDiagnosticReport: {
    methodKind: "unary";
    input: typeof SubmitDiagnosticReportRequestSchema;
    output: typeof SubmitDiagnosticReportResponseSchema;
  },
  /**
   * SubmitFeedback stores only text the signed-in person explicitly enters.
   * It never attaches diagnostics, files, environment variables, or command
   * history; those remain behind the separate diagnostic disclosure.
   *
   * @generated from rpc nodebase.v1.DeviceService.SubmitFeedback
   */
  submitFeedback: {
    methodKind: "unary";
    input: typeof SubmitFeedbackRequestSchema;
    output: typeof SubmitFeedbackResponseSchema;
  },
  /**
   * GetEnhancedDiagnosticPlan returns a short-lived, server-bounded carrier
   * echo plan. It is user-triggered by the hidden Desktop diagnostic page and
   * never carries the device's WireGuard identity or a Worker route.
   *
   * @generated from rpc nodebase.v1.DeviceService.GetEnhancedDiagnosticPlan
   */
  getEnhancedDiagnosticPlan: {
    methodKind: "unary";
    input: typeof GetEnhancedDiagnosticPlanRequestSchema;
    output: typeof GetEnhancedDiagnosticPlanResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_device, 0);

